import { render, staticRenderFns } from "./engineeringCompany.vue?vue&type=template&id=b39127e6&scoped=true"
import script from "./engineeringCompany.vue?vue&type=script&lang=js"
export * from "./engineeringCompany.vue?vue&type=script&lang=js"
import style0 from "./engineeringCompany.vue?vue&type=style&index=0&id=b39127e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39127e6",
  null
  
)

export default component.exports